import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, InfoIcon } from 'lucide-react';
import { alert } from '../data/homepage';
const ease = [0.23, 1, 0.32, 1] as const;
export function AlertBar() {
  const [expanded, setExpanded] = useState(false);
  return <div className="w-full bg-ville-lime text-ville-navy" data-id="element-40" data-mp="3tmdpr0v2r87a">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-41" data-mp="3tkj6rs3d5q5u">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2.5" data-id="element-42" data-mp="l8ez8eqvgf16">
          <InfoIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-43" data-mp="p8yufcrvx8ko" />
          <p className="text-sm font-extrabold" data-id="element-44" data-mp="b8wi062cj7ct">{alert.title}</p>
          {!expanded && <p className="hidden text-sm text-ville-navy/70 sm:block" data-id="element-45" data-mp="bb0jkhcrvu9x">{alert.detail}</p>}
          <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} aria-controls="alert-details" className="ml-auto inline-flex items-center gap-1.5 rounded text-sm font-extrabold underline-offset-4 transition-colors duration-150 ease-ville hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-navy" data-id="element-46" data-mp="g662r8esiuub">
            {expanded ? 'Show less' : 'Details'}
            <motion.span animate={{
            rotate: expanded ? 180 : 0
          }} transition={{
            duration: 0.2,
            ease
          }} className="inline-flex" data-id="element-47" data-mp="1owf3duujqzpz">
              <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="1xtpd3brpugss" />
            </motion.span>
          </button>
        </div>

        <AnimatePresence initial={false} data-id="element-49" data-mp="2bsp1qjf8avoy">
          {expanded && <motion.div id="alert-details" key="details" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          height: {
            duration: 0.28,
            ease
          },
          opacity: {
            duration: 0.18,
            ease
          }
        }} className="overflow-hidden" data-id="element-50" data-mp="27somiwkb2ggu">
              <motion.div initial={{
            y: -6
          }} animate={{
            y: 0
          }} exit={{
            y: -6
          }} transition={{
            duration: 0.24,
            ease
          }} className="max-w-3xl border-t border-ville-navy/20 pb-4 pt-3 text-sm leading-relaxed text-ville-navy/80" data-id="element-51" data-mp="2xnfmztdz1mod">
                {alert.body.map((paragraph, index) => <p key={paragraph} className={index === 0 ? undefined : 'mt-2'} data-id="element-52" data-mp="3ce4zcz3657tt" data-mpi={index}>
                    {paragraph}
                  </p>)}
                <p className="mt-2 text-ville-navy/60" data-id="element-53" data-mp="3lcgpl004i3lq">{alert.scope}</p>
              </motion.div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}